<template>
  <a-card :body-style="{ padding: 0, height: selectObj.height + 96 + 'px', overflowY: 'auto' }">
    <view-manage
      :select-obj="selectObj"
      @change="change"
    />
  </a-card>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
// import SideFieldRender from 'liyu-pc-base/components/SideSearchRender/SideFieldRender.vue';
// import { ReloadOutlined } from '@ant-design/icons-vue';
import ViewManage from 'liyu-pc-base/components/SideSearchRender/viewManage.vue';

export default defineComponent({
  name: 'SideSearchRender',
  components: {
    ViewManage,
  },
  props: {
    selectObj: {
      type: Object,
      required: true,
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const change = (data: any, is_refresh: any, is_ownView: any) => {
      emit('change', data, is_refresh, is_ownView);
    };
    return {
      props,
      change,
    };
  },
});
</script>
<style lang="less">
.collapses .ant-collapse-item .ant-collapse-content .ant-collapse-content-box {
  padding: 0;
}
</style>
